<template>
  <div class="public-reviews">
    <h2 class="vz-text-align-left">Отзывы</h2>
    <client-only>
      <vueper-slides
        ref="slider"
        no-shadow
        :slide-ratio=1/4
        :visible-slides=1
        :touchable="false"
        :arrows="reviewGroups.length < maxGroups"
        :arrows-outside="true"
        :bullets-outside="true"
      >
        <vueper-slide v-for="reviewGroup in reviewGroups">
          <template #content>
            <div class="public-reviews-group">
              <public-review v-for="review in reviewGroup" :review="review" />
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { getReviews } from '~/api/reviews';
import PublicReview from '~/components/public/public-review.vue';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css'

const maxGroups = 6

const reviews = await getReviews()

const reviewGroups = computed(() => {
  return [...Array(Math.ceil(reviews.length / 4))].map(_ => reviews.splice(0, 4))
})
</script>

<style lang="scss" scoped>
.public-reviews {

  :deep(h2) {
    margin-bottom: 40px;
  }

  :deep(.vueperslides) {
    @media screen and (max-width: $pub-xs) {
      max-width: 264px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;

    @media screen and (max-width: $pub-sm) {
      grid-template-columns: 1fr;
    }
  }

  :deep(.vueperslides__parallax-wrapper) {
    height: 560px !important;
    padding-bottom: 0 !important;

    @media screen and (max-width: $pub-sm) {
      height: 1120px !important;
    }

    @media screen and (max-width: $pub-xs) {
      height: 1360px !important;
    }

    &:after,
    &:before {
      box-shadow: none !important;
    }
  }

  :deep(.vueperslides__bullet) {
    .default {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $border-gray;
      border: none !important;
      box-shadow: none !important;
    }

    &.vueperslides__bullet--active {
      .default {
        background: $primary !important;
      }
    }
  }

  :deep(.vueperslides__arrow--prev) {
    bottom: -40px;
    left: calc(50% - 100px);
    top: auto;
    transform: none;
    
    svg {
      width: 12px;
      padding: 0;
    }
  }

  :deep(.vueperslides__arrow--next) {
    bottom: -40px;
    right: calc(50% - 94px);
    top: auto;
    transform: none;

    svg {
      width: 12px;
      padding: 0;
    }
  }
}
</style>
  